import { PublicClientApplication, LogLevel } from "@azure/msal-browser";
import { passwordChangeAuthority } from "./features/users/domain/passwordChange";

const appRedirectUri = window.location.origin;
const popupRedirectUri = `${window.location.origin}/silent-renew.html`;
const loginScopes = [
  "openid",
  "profile",
  "offline_access",
  process.env.REACT_APP_B2C_API_SCOPE ||
    "https://whygreneorg.onmicrosoft.com/4939cfd8-8880-42d7-980c-9006a053544a/api.read",
];

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_B2C_CLIENT_ID || "30653b6b-fa23-46cb-a01d-d4450fb91b1e",                                          // Azure AD B2C app client ID
    authority: process.env.REACT_APP_B2C_AUTHORITY || "https://whygreneorg.b2clogin.com/whygreneorg.onmicrosoft.com/B2C_1_Signin",    // Azure AD B2C authority URL
    knownAuthorities: [process.env.REACT_APP_B2C_KNOWN_AUTHORITIES || "whygreneorg.b2clogin.com"],                                    // Known authorities for B2C
    // Keep app-level redirects on the SPA root so handleRedirectPromise() runs in the main window.
    redirectUri: appRedirectUri,
    postLogoutRedirectUri: appRedirectUri, // Redirect after logout
    navigateToLoginRequestUrl: false, // Prevent navigation to login request URL
  },
  cache: {
    cacheLocation: "localStorage", // Prefer localStorage for more resilient silent SSO
    storeAuthStateInCookie: true,
  },
  // In your msalConfig object
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          default:
            break;
        }
      },
    },
    // Not using the native broker in browser contexts.
    allowNativeBroker: false,
    // Increased timeout to prevent premature monitor failure (monitor_window_timeout)
    iframeHashTimeout: 15000,
    // Keep default behavior (safer) unless you are embedding the app in an iframe and explicitly need redirects there.
    allowRedirectInIframe: false,
  },
};

export const redirectLoginRequest = {
  scopes: loginScopes,
  prompt: "login", // Ensure fresh login
  redirectUri: appRedirectUri,
};

export const popupLoginRequest = {
  scopes: loginScopes,
  prompt: "login", // Ensure fresh login
  // Popup/silent auth should land on a lightweight same-origin page so the SPA
  // does not boot inside the popup/iframe and rewrite the OAuth hash.
  redirectUri: popupRedirectUri,
};

// FE-234: the password-reset flow (B2C_1_changepassword) on the sign-in host and tenant.
export const passwordChangeRequest = {
  authority: passwordChangeAuthority(msalConfig.auth.authority),
  scopes: ["openid"],
  redirectUri: popupRedirectUri,
};

export const silentRequest = {
  scopes: loginScopes,
  redirectUri: popupRedirectUri,
  // Scopes for silent token request
  forceRefresh: false, // Use cached token when available
};

export const ssoSilentRequest = {
  authority: msalConfig.auth.authority,
  redirectUri: popupRedirectUri,
};
